import { createSlice, createSelector, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../store';

export interface EventFilterStateType {
    search: string;
    page: number;
    orderBy: string;
    orderDir: string;
    startDate: string; // Use string (ISO format) or Date depending on your handling
    endDate: string;
    status: string;
}

const initialState: EventFilterStateType = {
    search: '',
    page: 1,
    orderBy: 'start_date',
    orderDir: '-',
    startDate: '',
    endDate: '',
    status: '',
};

export const eventFilterSlice = createSlice({
    name: 'eventFilter',
    initialState,
    reducers: {
        setSearch: (state, action: PayloadAction<string>) => {
            state.page = 1;
            state.search = action.payload;
        },
        setPage: (state, action: PayloadAction<number>) => {
            state.page = action.payload;
        },
        setOrderBy: (state, action: PayloadAction<string>) => {
            state.orderBy = action.payload;
        },
        setOrderDir: (state, action: PayloadAction<string>) => {
            state.orderDir = action.payload;
        },
        setStartDate: (state, action: PayloadAction<string>) => {
            state.page = 1;
            state.startDate = action.payload;
        },
        setEndDate: (state, action: PayloadAction<string>) => {
            state.page = 1;
            state.endDate = action.payload;
        },
        setStatus: (state, action: PayloadAction<string>) => {
            state.page = 1;
            state.status = action.payload;
        },
        setAllFilters: (state, action: PayloadAction<EventFilterStateType>) => {
            return { ...state, ...action.payload };
        },
    },
});

export const {
    setSearch,
    setPage,
    setOrderBy,
    setOrderDir,
    setStartDate,
    setEndDate,
    setStatus,
    setAllFilters,
} = eventFilterSlice.actions;

export default eventFilterSlice.reducer;

export const eventFilterSelector = (state: RootState) => state.eventFilter;

export const searchSelector = createSelector(
    [eventFilterSelector],
    (filters) => filters.search
);

export const pageSelector = createSelector(
    [eventFilterSelector],
    (filters) => filters.page
);

export const orderBySelector = createSelector(
    [eventFilterSelector],
    (filters) => filters.orderBy
);

export const orderDirSelector = createSelector(
    [eventFilterSelector],
    (filters) => filters.orderDir
);

export const startDateSelector = createSelector(
    [eventFilterSelector],
    (filters) => filters.startDate
);

export const endDateSelector = createSelector(
    [eventFilterSelector],
    (filters) => filters.endDate
);

export const statusSelector = createSelector(
    [eventFilterSelector],
    (filters) => filters.status
);

export const eventSelector = createSelector(
    [eventFilterSelector],
    (filters) => filters
);
